import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import { deleteVehicleProperty, fetchVehicleProperty, setVehicleProperty } from '../actions';
import { selectVehicle, selectVehicleProperty } from '../selectors';
import { VehiclePropertyLoadable } from './VehiclePropertyLoadable';
import { WithVehicleProperty } from './WithVehicleProperty';
import { Checkbox } from '../../../components/Checkbox';
import CheckboxComponent from '../../../containers/App/Components/Checkbox/Checkbox';
import { Label } from './VehicleCounterLabel';
import { VehicleStatusLabel } from './VehicleStatusLabel';

const STATE = {};

export const TaskAssignable = {
  Teun: '0',
  Arjan: '1',
  Len: '2',
  Stefan: '3',
  Overig: '4',
};

export const TransportAssignableOptions = _.map(TaskAssignable, (value, name) => ({ label: name, value: value }));

/* eslint-disable react/prefer-stateless-function */
class VehiclePropertyCheckboxComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
    });
  }

  componentDidMount() {}

  get value() {
    return this.props.changedValue || this.props.value || this.props.vehicle?.[this.props.propertyName];
    // return this.props.changedValue || this.props.value;
  }

  toggle() {
    if (this.value === '1' || this.value === '2' || this.value === '3') {
      this.props.setField(this.props.propertyName, '0');
    } else {
      this.props.setField(this.props.propertyName, '1');
    }
  }

  render() {
    //  if (this.props.loading) return <Loader small />;
    const name = this.props.propertyName;

    if (this.props.vehicle?.id) {
      return (
        <VehiclePropertyLoadable name={name}>
          <Checkbox
            key={name}
            checked={this.value === '1' || this.value === '2' || this.value === '3'}
            onChange={this.toggle.bind(this)}
          >
            {this.lbl(`vehicle.property.${name}`)}&nbsp;
            {this.value == '1' ? (
              <VehicleStatusLabel status={this.value}>
                {this.lbl('vehicle.plannable.status.' + this.value)}
              </VehicleStatusLabel>
            ) : this.value == '2' ? (
              <VehicleStatusLabel status={this.value}>
                {this.lbl('vehicle.plannable.status.' + this.value)}
              </VehicleStatusLabel>
            ) : this.value == '3' ? (
              <VehicleStatusLabel status={this.value}>
                {this.lbl('vehicle.plannable.status.' + this.value)}
              </VehicleStatusLabel>
            ) : (
              ''
            )}
          </Checkbox>
        </VehiclePropertyLoadable>
      );
    }

    return (
      <WithVehicleProperty doFetch vehicleId={this.props.vehicleId} propertyName={name} key={name}>
        <VehiclePropertyLoadable name={name}>
          <Checkbox
            key={name}
            checked={this.value === '1' || this.value === '2' || this.value === '3'}
            onChange={this.toggle.bind(this)}
          >
            {this.lbl(`vehicle.property.${name}`)}&nbsp;
            {this.value == '1' ? (
              <VehicleStatusLabel status={this.value}>
                {this.lbl('vehicle.plannable.status.' + this.value)}
              </VehicleStatusLabel>
            ) : this.value == '2' ? (
              <VehicleStatusLabel status={this.value}>
                {this.lbl('vehicle.plannable.status.' + this.value)}
              </VehicleStatusLabel>
            ) : this.value == '3' ? (
              <VehicleStatusLabel status={this.value}>
                {this.lbl('vehicle.plannable.status.' + this.value)}
              </VehicleStatusLabel>
            ) : (
              ''
            )}
          </Checkbox>
        </VehiclePropertyLoadable>
      </WithVehicleProperty>
    );
  }
}

VehiclePropertyCheckboxComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    value: selectVehicleProperty(ownProps.vehicleId, ownProps.propertyName),
    vehicle: selectVehicle(ownProps.vehicleId),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,

    toggle() {
      dispatch(
        setVehicleProperty(ownProps.vehicleId, ownProps.propertyName, '1', () => {
          ownProps.toggleState(ownProps.propertyName);
          dispatch(fetchVehicleProperty(ownProps.vehicleId, ownProps.propertyName));
        }),
      );
    },
    deleteProperty() {
      dispatch(
        deleteVehicleProperty(ownProps.vehicleId, ownProps.propertyName, () => {
          ownProps.toggleState(ownProps.propertyName);
          dispatch(fetchVehicleProperty(ownProps.vehicleId, ownProps.propertyName));
        }),
      );
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const VehiclePropertyCheckbox = compose(withConnect, withRouter)(VehiclePropertyCheckboxComp);
